module.exports = __webpack_public_path__ + "img/_ico.f9709774.svg";